export default __webpack_public_path__ + "static/media/IUSD+.328d55b4.png";